import React from 'react'
import styled from 'styled-components'
import Circle from '~/components/Circle'
import Text, { FontStyle } from '~/components/core/Text'
import FillSlider from '~/components/FillSlider'
import { light } from '~/constants/theme'
import { CallTranscript } from '~/types/CallTranscript'
import { convertCallDuration } from '~/utils/formatter'

interface AgentTalkTimeStatWrapperProps {
  width: number
  margin?: string
}

const AgentTalkTimeStatWrapper = styled.div<AgentTalkTimeStatWrapperProps>`
  display: flex;
  flex-direction: column;
  width: ${(props) => props.width}px;
  margin: ${(props) => props.margin ?? ''};
`

const StatsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 15px;
  margin-bottom: 1px;
`

interface AgentTalkTimeStatProps {
  transcript: CallTranscript
  width?: number
  margin?: string
}

const AgentTalkTimeStat = ({
  transcript,
  width,
  margin,
}: AgentTalkTimeStatProps) => {
  const agentTalkTimeMillis =
    transcript.ConversationCharacteristics.TalkTime.DetailsByParticipant.AGENT
      ?.TotalTimeMillis ?? 0
  const agentTalkTimeSeconds = (agentTalkTimeMillis / 1000) | 0

  const customerTalkTimeMillis =
    transcript.ConversationCharacteristics.TalkTime.DetailsByParticipant
      .CUSTOMER?.TotalTimeMillis ?? 0
  const customerTalkTimeSeconds = (customerTalkTimeMillis / 1000) | 0

  const totalTalkTimeSeconds = agentTalkTimeSeconds + customerTalkTimeSeconds
  const agentTalkTimePercentage = agentTalkTimeSeconds / totalTalkTimeSeconds
  const customerTalkTimePercentage =
    customerTalkTimeSeconds / totalTalkTimeSeconds

  const sadColor = light.red100
  const neutralColor = light.dark300

  const agentTalkTimeColor =
    agentTalkTimePercentage > 0.8 ? sadColor : neutralColor
  return (
    <AgentTalkTimeStatWrapper width={width ?? 300} margin={margin}>
      <Text fontStyle={FontStyle.ButtonBold}>Agent Talk Time</Text>
      <FillSlider
        height={14}
        width={width ?? 300}
        fillPercentage={agentTalkTimePercentage}
        fillColor={agentTalkTimeColor}
        backgroundColor={light.dark600}
        fillBorderRadius="4px 0px 0px 4px"
        fillBorder="1px solid"
        fillBorderColor={`transparent ${light.gray200} transparent transparent`}
        borderRadius={4}
        margin="4px 0px 3px 0px"
        animate
      />
      <StatsWrapper>
        <Circle
          radius={6}
          color={agentTalkTimeColor}
          margin="0px 5px 0px 0px"
        />
        <Text fontStyle={FontStyle.TinySmall}>
          Talking: {convertCallDuration(agentTalkTimeSeconds)} (
          {Math.round(agentTalkTimePercentage * 100).toFixed(0)}%)
        </Text>
      </StatsWrapper>
      <StatsWrapper>
        <Circle radius={6} color={light.dark600} margin="0px 5px 0px 0px" />
        <Text fontStyle={FontStyle.TinySmall}>
          Listening: {convertCallDuration(customerTalkTimeSeconds)} (
          {Math.round(customerTalkTimePercentage * 100).toFixed(0)}%)
        </Text>
      </StatsWrapper>
    </AgentTalkTimeStatWrapper>
  )
}

export default AgentTalkTimeStat
